var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConrollerActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9941,
    cy: 34,
    r: 24,
    fill: "#00B0F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9941,
    cy: 34,
    r: 29,
    stroke: "#00B0F0",
    strokeOpacity: 0.1,
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4941 29.75C29.4941 27.2891 31.498 25.25 33.9941 25.25C36.4551 25.25 38.4941 27.2891 38.4941 29.75C38.4941 32.2461 36.4551 34.25 33.9941 34.25C31.498 34.25 29.4941 32.2461 29.4941 29.75ZM36.8066 29.75C36.8066 28.2031 35.541 26.9375 33.9941 26.9375C32.4121 26.9375 31.1816 28.2031 31.1816 29.75C31.1816 31.332 32.4121 32.5625 33.9941 32.5625C35.541 32.5625 36.8066 31.332 36.8066 29.75ZM33.4668 37.9062L32.3066 35.9375H35.6816L34.4863 37.9062L35.0488 39.9805L36.7715 36.5352C39.6191 36.8516 41.8691 39.2422 41.8691 42.1953C41.8691 42.793 41.377 43.25 40.7793 43.25H27.1738C26.5762 43.25 26.1191 42.793 26.1191 42.1953C26.1191 39.2422 28.334 36.8516 31.1816 36.5352L32.9043 39.9805L33.4668 37.9062ZM37.6855 38.5039L36.1387 41.5625H40.1113C39.9004 40.1914 38.9512 39.0312 37.6855 38.5039ZM27.8418 41.5625H31.8145L30.2676 38.5039C29.002 39.0312 28.0527 40.1914 27.8418 41.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConrollerActive);
export default __webpack_public_path__ + "static/media/conroller_active.a24b35335fff2cedf6a18364d3e86356.svg";
export { ForwardRef as ReactComponent };